import { ResizeObserver as t } from "../../../../../../@juggle_resize-observer@3.4.0/node_modules/@juggle/resize-observer/lib/ResizeObserver.js";
import "../../../../../../@juggle_resize-observer@3.4.0/node_modules/@juggle/resize-observer/lib/algorithms/calculateBoxSize.js";
class i {
  constructor() {
    this.handleResize = this.handleResize.bind(this), this.observer = new (typeof window != "undefined" && window.ResizeObserver || t)(this.handleResize), this.elHandlersMap = /* @__PURE__ */ new Map();
  }
  handleResize(e) {
    for (const s of e) {
      const r = this.elHandlersMap.get(s.target);
      r !== void 0 && r(s);
    }
  }
  registerHandler(e, s) {
    this.elHandlersMap.set(e, s), this.observer.observe(e);
  }
  unregisterHandler(e) {
    this.elHandlersMap.has(e) && (this.elHandlersMap.delete(e), this.observer.unobserve(e));
  }
}
const o = new i();
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/resize-observer/src/delegate.js
// module id = 990
// module chunks = 67